import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { arrayUnion, doc, setDoc } from 'firebase/firestore';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Recommender, UserStatus } from '../../../consts/types/user';
import { db } from '../../../firebase';
import { UserSelectors, userActionsCreators } from '../../../reducers/user';
const { NotificationManager } = require('react-notifications');

interface AddRecommenderDialogProps {
    setIsAddingRecommender: (isAdding: boolean) => void;
    setIsSavingRecommender: (isSaving: boolean) => void;
    isAddingRecommender: boolean;
    isSavingRecommender: boolean;

}

type Props = AddRecommenderDialogProps;


const AddRecommenderDialog: FC<Props> = (props: Props) => {
    const { isAddingRecommender, isSavingRecommender, setIsAddingRecommender, setIsSavingRecommender } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const user = useSelector(UserSelectors.currentUser);
    const [recommenders, setRecommenders] = useState(user?.recommenders || []);
    const [newRecommender, setNewRecommender] = useState<Recommender>({ status: UserStatus.Pending } as any);

    const dispatch = useDispatch();

    useEffect(() => {
        setRecommenders(user?.recommenders || []);
    }, [user?.recommenders]); //eslint-disable-line

    const clearRecommender = () => {
        setNewRecommender({ status: UserStatus.Pending } as any);

    }
    const addNewRecommender = () => {
        if (user?.email && newRecommender.name && newRecommender.email && newRecommender.role && newRecommender.phone) {
            setIsSavingRecommender(true);
            setIsAddingRecommender(false);

            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, recommenders: [...(user.recommenders || []), newRecommender] } }));
            }
            setDoc(doc(db, "users", user.email), {
                recommenders: arrayUnion(newRecommender),
            }, { merge: true })
                .then((result) => {
                    NotificationManager.success('Recommender added successfully!',);
                    setIsSavingRecommender(false);
                })
                .catch(() => {
                    setIsSavingRecommender(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
            clearRecommender();
        }
    }
    return <Dialog fullScreen={fullScreen} fullWidth onClose={() => { setIsAddingRecommender(false) }} open={isAddingRecommender}>
        <DialogTitle>Add Recommender</DialogTitle>
        <Box px={2} minWidth="30%">
            <Stack spacing={3}>
                <TextField size="small" type="text" value={newRecommender.name} onChange={e => setNewRecommender({ ...newRecommender, name: e.target.value })} label="Name" fullWidth required />
                <TextField size="small" type="text" value={newRecommender.role} onChange={e => setNewRecommender({ ...newRecommender, role: e.target.value })} label="Role" fullWidth required />
                <TextField size="small" type="email" value={newRecommender.email} onChange={e => setNewRecommender({ ...newRecommender, email: e.target.value })} label="Email" fullWidth required />
                <TextField size="small" type="text" value={newRecommender.phone} onChange={e => setNewRecommender({ ...newRecommender, phone: e.target.value })} label="Phone" fullWidth required />

            </Stack>
            <Box display="flex" justifyContent="center" my={4}>
                <Button onClick={() => { clearRecommender(); setIsAddingRecommender(false); }} color="inherit" sx={{ mr: 2 }}>Cancel</Button>
                <Button variant="contained" onClick={addNewRecommender} disabled={isSavingRecommender}>Submit</Button>
            </Box>
        </Box>
    </Dialog>;
}


export default AddRecommenderDialog;

